import { useState } from 'react';
import Modal from './Modal';


const Button = ({ attributes }) => {
    const [modal, setModal] = useState(false)
    const { content, title } = attributes;
    const { btnText, } = content;

    const modalPorps = { content, title, modal, setModal }

    return <div className='bpsmb_modal_plugin'>
        {/* Button */}
        <div className='bpsmb_button_area'>

            <button onClick={() => setModal(true)} className='btn'>{btnText}</button>
        </div>

        {/* Modal */}
        {modal && <Modal {...modalPorps} />}


    </div>
}
export default Button;